import React from "react";
import { Title, BlockCode, Code } from "./Components";

export default {
  h1: Title,
  h2: ({ children }) => (
    <h2 className="my-4 text-2xl text-blue-100">{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className="my-2 text-xl text-blue-100">{children}</h3>
  ),
  ul: ({ children }) => (
    <ul className="list-disc list-outside my-2 pl-4">{children}</ul>
  ),
  li: ({ children }) => <li className="text-white">{children}</li>,
  p: ({ children }) => <p className={`text-white `}>{children}</p>,
  a: (props) => (
    <a
      href={props.href}
      target="_blank"
      className="text-blue-100"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  ),
  code: Code,
  pre: BlockCode,
  hr: () => <hr className="my-4" />,
  img: ({ src, alt }) => (
    <img src={src} alt={alt} className="inline-block my-4" />
  ),
  table: ({ children }) => (
    <table className="my-4 border-collapse table-auto borer">{children}</table>
  ),
  th: ({ children }) => <th className="p-2 border">{children}</th>,
  td: ({ children }) => <td className="p-2 border">{children}</td>
};
